import axios from 'axios';

const api = axios.create({
    baseURL: '',
});

// Public API
export const getArticles = (params = {}) => api.get('/api/articles', { params });
export const getArticle = (slug) => api.get(`/api/articles/${slug}`);
export const getCategories = () => api.get('/api/categories');
export const getRelatedArticles = (slug) => api.get(`/api/articles/${slug}/related`);

// Admin API
export const getAdminArticles = () => api.get('/api/admin/articles');
export const getAdminArticle = (id) => api.get(`/api/admin/articles/${id}`);
export const createArticle = (data) => api.post('/api/admin/articles', data);
export const updateArticle = (id, data) => api.put(`/api/admin/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/api/admin/articles/${id}`);
export const uploadImage = (formData) => api.post('/api/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
});
export const generateSlug = (title) => api.get('/api/admin/generate-slug', { params: { title } });

export default api;
